import { Controller } from "@hotwired/stimulus"

// Mobile navigation — full-screen Deep overlay menu (CLAUDE_DESIGN §8).
// Escape closes; body scroll locks while open; focus moves into the menu.
export default class extends Controller {
  static targets = ["menu"]

  open()  { this.toggle(true) }
  close() { this.toggle(false) }

  toggle(state) {
    if (!this.hasMenuTarget) return
    this.menuTarget.hidden = !state
    document.body.style.overflow = state ? "hidden" : ""

    if (state) {
      this.keyHandler = (e) => { if (e.key === "Escape") this.close() }
      document.addEventListener("keydown", this.keyHandler)
      const first = this.menuTarget.querySelector("a, button")
      if (first) first.focus()
    } else if (this.keyHandler) {
      document.removeEventListener("keydown", this.keyHandler)
      this.keyHandler = null
    }
  }

  disconnect() {
    document.body.style.overflow = ""
    if (this.keyHandler) document.removeEventListener("keydown", this.keyHandler)
  }
}
